export const environment = {
    production: false,
    apiUrl: 'https://transportbend.h2a2.net/',
    siteKey: '6LeilfUqAAAAAHRAkGZNc8nEBsmiSQbwx4dyxz86',
    storageName:'sharedData@transportbendv2'
};
